let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("cygJy")]).then(() => parcelRequire('l1Z7j'));